module.exports = __webpack_public_path__ + "static/media/tapleyjung4.e87758f0.ogg";